import { htmlAttributes, newRelicConstants } from '../constants';
import { persistViewConversionBeacon } from './helpers';
import { triggerAdTimeLogs, triggerNewRelic } from './newRelicHelpers';
import { newRelicDataTestId } from '../constants/newRelicConstants';

const pushToDDO = (event) => {
  window.digitalData = window.digitalData || {};
  window.digitalData.event = window.digitalData.event || [];
  window.digitalData.event.push(event);
};

export const pushImpressionToAdobe = (element) => {
  const campaignId = element?.getAttribute?.(htmlAttributes.DATA_CAMPAIGN_ID);
  const placementId = element?.getAttribute?.(htmlAttributes.DATA_PLACEMENT_ID);
  const slotId = element?.getAttribute?.(htmlAttributes.DATA_SLOT_ID);
  let flightId = element?.getAttribute?.(htmlAttributes.DATA_FLIGHT_ID);

  const creativeId = element?.getAttribute?.(htmlAttributes.DATA_CREATIVE_ID);
  const getImpressionId = (el) => {
    try {
      const onviewBeacon = el?.getAttribute(htmlAttributes.ONVIEW_BEACON_NUCLEUS)
        || el?.getAttribute(htmlAttributes.DATA_ONVIEW_BEACON_NUCLEUS);
      const queryString = onviewBeacon.split('?')[1];
      const idField = queryString.split('&')[0];
      const impressionId = idField.split('=')[1];
      return impressionId;
    } catch {
      return '';
    }
  };

  let event = {
    category: { primaryCategory: 'content display' },
    eventInfo: { eventName: 'piq impression' }, // should be updated to be ad server agnostic
    data: {
      impressionID: getImpressionId(element),
      campaignID: campaignId || '',
      placementID: placementId || '',
      slotID: slotId || '',
      flightID: flightId !== 'undefined' ? flightId : ''
    }
  };

  if (creativeId) {
    event.data.creativeID = creativeId;
  }

  pushToDDO(event);

};

export const sendDefaultBannerImpression = () => {
  let event = {
    category: { primaryCategory: 'content display' },
    eventInfo: { eventName: 'piq impression' },
    data: {
      impressionID: newRelicConstants.DEFAULT_BANNER,
      campaignID: newRelicConstants.DEFAULT_BANNER,
      placementID: newRelicConstants.DEFAULT_BANNER,
      slotID: newRelicConstants.DEFAULT_BANNER
    }
  };

  pushToDDO(event);
};

export const shouldTrackImpressions = (queryParams) => {
  const areImpressionsEnabledOnLocalhost = !!queryParams.enableLocalImpressions;
  if (areImpressionsEnabledOnLocalhost || !window.location.host.includes('localhost')) {
    return true;
  }
  return false;
};

function handleImpression(element, onviewbeacon, dataTestId) {
  const adLoadStartTime = new Date(Number(element.getAttribute(htmlAttributes.DATA_AD_LOAD_TIMESTAMP))).getTime();
  const bannerInitTime = new Date(Number(element.getAttribute(htmlAttributes.DATA_BANNER_INIT_TIMESTAMP))).getTime();
  const innervateScriptTime = new Date(Number(element.getAttribute(htmlAttributes.DATA_INV_SCRIPT_TIMESTAMP))).getTime();
  const beaconAddTime = new Date(Number(element.getAttribute(htmlAttributes.DATA_BEACON_ADD_TIME))).getTime();
  const slotId = element.getAttribute(htmlAttributes.DATA_SLOT_ID);
  const adServer = element.getAttribute(htmlAttributes.DATA_ADSERVER);
  const viewConversionBeacon = element.getAttribute(htmlAttributes.DATA_ON_VIEW_CONVERSION_BEACON);
  const mcvisID = element.getAttribute(htmlAttributes.DATA_MCVISID);

  const existingImg = document.querySelector(`img[src="https:${onviewbeacon}"]`);
  if (!existingImg) {
    let beaconStr = `<img class="onviewbeacon" style="display:none;" src="https:${onviewbeacon}">`;
    document.body.insertAdjacentHTML('beforeend', beaconStr);
    if (window && !window.SponsoredBannerImpressions) {
      window.SponsoredBannerImpressions = {};
    }
    window.SponsoredBannerImpressions[onviewbeacon] = true;
  }
  // Impression Fired Time
  const impressionFiredTime = Date.now();

  if (viewConversionBeacon && mcvisID) {
    persistViewConversionBeacon({
      conversionBeacon: viewConversionBeacon,
      mcvisID
    });
  }

  triggerAdTimeLogs(dataTestId, adLoadStartTime, bannerInitTime, innervateScriptTime, beaconAddTime, impressionFiredTime, adServer);

  element.setAttribute(htmlAttributes.DATA_H1_BEACON, onviewbeacon);
  if (!element.classList.contains('sponsored-product-pod')
    && !element.classList.contains('sponsored-pip-pla-container')) {
    pushImpressionToAdobe(element);
  }
  const newRelicAdType = newRelicDataTestId[dataTestId];
  if (newRelicAdType) {
    triggerNewRelic(newRelicAdType, `impression-${adServer}-${slotId}`);
  }

}

export const triggerBeacon = (element) => {
  let onviewbeacon = element.getAttribute(htmlAttributes.ONVIEW_BEACON_NUCLEUS)
    || element.getAttribute(htmlAttributes.DATA_ONVIEW_BEACON_NUCLEUS);
  const dataTestId = element.getAttribute(htmlAttributes.DATA_TEST_ID);
  if (onviewbeacon) {
    handleImpression(element, onviewbeacon, dataTestId);
  } else if (dataTestId === 'default-standard-banner' && !window.DefaultBannerImpressions) {
    // set a beacon for default banner to indicate impression sent
    window.DefaultBannerImpressions = true;
    element.setAttribute(htmlAttributes.DATA_H1_BEACON, 'default-banner');
    triggerNewRelic(newRelicConstants.DEFAULT_BANNER, 'impression');
    sendDefaultBannerImpression();
  }
};
